import { createSelector } from "reselect";
import { values, filter } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.habitType;

const getManglik = createSelector(getData, habitType =>
  filter(values(habitType), item => item.value !== "occasionally")
);

export default getManglik;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getManglik.js